import React, { Suspense, lazy } from 'react';
import './components/UI/CSS/App.css';

// Libraries
// import { Button } from '@chakra-ui/core';

// React router
import { Switch, Route } from 'react-router-dom';


// Components
import { Loader } from './components/UI/Loader';

// Importing Routes lazily
const Landing = lazy(() => import("./components/landing"));
const SMS = lazy(() => import("./components/sms"));
const Email = lazy(() => import("./components/email"));

const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path="/">
          <Landing />
        </Route>

        {/* <Route exact path="/sms">
          <SMS />
        </Route> */}

        <Route exact path="/sms/:number">
          <SMS />
        </Route>


        {/* <Route exact path="/email">
          <Email />
        </Route> */}

        <Route exact path="/email/:email">
          <Email />
        </Route>


        <Route exact path="/voice/:number">
          <SMS isVoice={true} />
        </Route>

      </Switch>
    </Suspense>
  );
}

export default App;